import * as _ from "lodash";
import * as THREE from "three";
import {Node} from "../Node";
import {_toThreeComplex, _toThreeValuePromise, AbstractProperty} from "./AbstractProperty";
import {json, MetadataRow, PropertyParameters} from "../../global";

export class PEuler extends AbstractProperty<[number, number, number], Node> {

    default: [number, number, number];
    dimensionLabels: string[];
    inputScale: number;

    constructor(args: PropertyParameters) {
        super({
            type: 'Euler',
            default: args.default ?? [0,0,0],
            inputScale: 180 / Math.PI,
            dimensionLabels: ['x°', 'y°', 'z°'],
            ...args
        });
    }

    typeCheck(value) {
        return _.isArray(value) && value.length == 3;
    }

    isEqual(a: [number, number, number], b: [number, number, number]): boolean {
        return _.isEqual(a,b);
    }

    toJSON(): json {
        return _.clone(this.get());
    }

    fromJSON(json: json): this {
        this.set(json[this.name]);
        return this;
    }

    toThree(instance: any) {
        _toThreeComplex(this, instance, "Euler",
            (instance, value) => _toThreeValuePromise(new THREE.Euler()),
            (instance, value, instanceValue, freshlyCreated) => instanceValue.set(value[0], value[1], value[2], 'XYZ'));
    }

    threeToInternalFormat(value: THREE.Euler): number[] {
        if (value == null) {
            return null;
        }
        if (value.order != 'XYZ') {
            value = value.clone().reorder('XYZ');
        }
        return [value.x, value.y, value.z];
    }

    fromMetadataRow(metadataRow: MetadataRow): this {
        this.set(metadataRow[this.name]?.toArray()?.slice(0, 3));
        return this;
    }

    toMetadataRow(metadataRow: MetadataRow): this {
        metadataRow[this.name] = new THREE.Euler().fromArray(this.get());
        return this;
    }

}
